import { Center, Group, Image, Stack, Text, rem } from '@mantine/core';

import type { EmptyStateViewProps } from './EmptyState.types';
import defaultIllustration from './empty-state.png';

export function EmptyStateView({
  variant = 'feature',
  title,
  description,
  illustration,
  action,
  secondaryAction,
}: EmptyStateViewProps) {
  const resolvedIllustration =
    illustration ??
    (variant === 'inline' ? undefined : <Image src={defaultIllustration} alt="" w={rem(120)} />);

  if (variant === 'inline') {
    return (
      <Group gap="sm" wrap="nowrap" align="center">
        {illustration && (
          <div style={{ flexShrink: 0, color: 'var(--mantine-color-dimmed)' }}>
            {illustration}
          </div>
        )}
        <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
          <Text size="sm" fw={500} c="dimmed">
            {title}
          </Text>
          {description && (
            <Text size="xs" c="dimmed">
              {description}
            </Text>
          )}
        </Stack>
        {action && <div style={{ flexShrink: 0 }}>{action}</div>}
      </Group>
    );
  }

  if (variant === 'page') {
    return (
      <Center style={{ minHeight: rem(320) }}>
        <Stack align="center" gap="lg" style={{ maxWidth: rem(480), textAlign: 'center' }}>
          {resolvedIllustration && (
            <div style={{ flexShrink: 0 }}>{resolvedIllustration}</div>
          )}
          <Stack gap="xs" align="center">
            <Text fw={700} size="xl">
              {title}
            </Text>
            {description && (
              <Text size="sm" c="dimmed" style={{ maxWidth: rem(360) }}>
                {description}
              </Text>
            )}
          </Stack>
          {(action || secondaryAction) && (
            <Group gap="sm" justify="center">
              {action}
              {secondaryAction}
            </Group>
          )}
        </Stack>
      </Center>
    );
  }

  return (
    <Group gap="md" wrap="wrap" align="center" style={{ maxWidth: rem(600) }}>
      {resolvedIllustration && (
        <div style={{ flexShrink: 0 }}>{resolvedIllustration}</div>
      )}
      <Stack gap={4} style={{ flex: 1, minWidth: rem(180) }}>
        <Text fw={600}>{title}</Text>
        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
      </Stack>
      {action && <div style={{ flexShrink: 0 }}>{action}</div>}
    </Group>
  );
}
